import { useEffect, useState } from "react";
import { ButtonCustom } from "../../../../components/custom/button-custom";
import { ModalCustom } from "../../../../components/custom/modal-custom";
import { DetailBrandResponse } from "../../../../models/response/brand-response";

interface BrandInfoProps {
  dataDetail: DetailBrandResponse;
  isOpenDetail: boolean;
  setIsOpenDetail: (value: boolean) => void;
}

export const BrandInfo = ({ dataDetail, isOpenDetail, setIsOpenDetail }: BrandInfoProps) => {
  const [dataDetailBrand, setDataDetailBrand] = useState<DetailBrandResponse>(new DetailBrandResponse());

  useEffect(() => {
    setDataDetailBrand(dataDetail);
  }, [dataDetail]);

  const bodyModal = () => {
    return (
      <div className="flex flex-col  gap-3">
        <div className="grid grid-cols-1  gap-3">
          <div className="flex">
            <label htmlFor="employeeName" className="w-1/3 font-bold text-sm text-gray-600">
              Tên đăng nhập:
            </label>
            <span className="w-2/3 text-gray-600 font-medium text-sm">{dataDetailBrand.username}</span>
          </div>
          <div className="flex">
            <label htmlFor="birthday" className="w-1/3 font-bold text-sm text-gray-600">
              Mật khẩu:
            </label>
            <span className="w-2/3 text-gray-600 font-medium text-sm">{dataDetailBrand.password}</span>
          </div>
          <div className="flex justify-center">
            <img src={dataDetailBrand.totp_qr_code} alt="" />
          </div>
        </div>
      </div>
    );
  };
  const footerModal = () => {
    return (
      <ButtonCustom
        type="button"
        text="Đóng"
        onClick={() => {
          setIsOpenDetail(false);
        }}
        className="bg-gray-100 text-gray-500 hover:bg-gray-400 hover:text-white"
      />
    );
  };

  return (
    <ModalCustom
      isOpen={isOpenDetail}
      setIsOpen={setIsOpenDetail}
      titleModal="Thông tin đăng nhập"
      bodyModal={bodyModal()}
      footerModal={footerModal()}
      modalSize={"40%"}
    />
  );
};
